"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AlertModal = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));

var _Modal = _interopRequireDefault(require("@material-ui/core/Modal"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var styles = function styles(theme) {
  return {
    root: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      left: '50%',
      margin: 'auto',
      maxWidth: '500px',
      padding: '1rem',
      position: 'absolute',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      width: '80%'
    },
    button: {
      "float": 'right',
      margin: '2px'
    }
  };
};

var AlertModal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AlertModal, _React$Component);

  function AlertModal(props) {
    _classCallCheck(this, AlertModal);

    return _possibleConstructorReturn(this, _getPrototypeOf(AlertModal).call(this, props));
  }

  _createClass(AlertModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          action = _this$props.action,
          classes = _this$props.classes,
          closeModal = _this$props.closeModal,
          header = _this$props.header,
          open = _this$props.open,
          subh = _this$props.subh;

      var cancelButton = _react["default"].createElement(_Button["default"], {
        className: classes.button,
        color: "secondary",
        onClick: closeModal
      }, "Cancelar");

      return _react["default"].createElement(_Modal["default"], {
        open: open || false,
        onClose: closeModal
      }, _react["default"].createElement("div", {
        className: classes.root
      }, _react["default"].createElement(_Typography["default"], {
        color: "inherit",
        variant: "h6"
      }, header), _react["default"].createElement(_Typography["default"], {
        color: "inherit",
        gutterBottom: true,
        variant: "subtitle1"
      }, subh), _react["default"].createElement(_Button["default"], {
        id: "actionModal",
        className: classes.button,
        color: "secondary",
        onClick: action ? action : closeModal,
        variant: "contained"
      }, "Aceptar"), action ? cancelButton : null));
    }
  }]);

  return AlertModal;
}(_react["default"].Component);

exports.AlertModal = AlertModal;

var _default = (0, _styles.withStyles)(styles, {
  withTheme: true
})(AlertModal);

exports["default"] = _default;